// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import { Controller } from 'react-hook-form'
import { StyledError } from './contact-us-styles'
import { getBase64MimeType } from '../../../utils/utils'
import TypographyPro from '../../../themes/TypographyPro'

const MAX_UPLOAD_SIZE_IN_KB = 5000 * 1000

const allowedMimeTypes = new Set([
	'image/png',
	'image/jpg',
	'image/jpeg',
	'application/msword',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'image/gif',
	'audio/mpeg',
	'video/mp4',
	'application/vnd.oasis.opendocument.text',
	'application/pdf',
])

const StyledUploadContainer = styled.div`
	background-color: var(--optionalBackground);
	border-radius: 5px;
	min-height: 84px;
	display: flex;
	justify-content: center;
	align-items: center;
`

const StyledUpload = styled.div`
	min-height: 72px;
	width: 96%;
	border: 1px dashed #686767;
	box-sizing: border-box;
	border-radius: 5px;
	display: flex;
	justify-content: center;
	align-items: center;
`

const StyledList = styled.div`
	display: flex;
	flex-direction: column;
`

const StyledListItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`

const StyledText = styled(TypographyPro)``

const StyledFileName = styled(TypographyPro)`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

const StyledUploadInput = styled.input`
	display: none;
`

const StyledIconButton = styled(IconButton)`
	padding: 12px 0 12px 12px;
`

const convertToBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = () => resolve(reader.result)
		reader.onerror = (error) => reject(error)
	})
// shouldn't check with file name since it can be misleading (executable file with .doc extension in name)
// can possibly be added as a custom validation to react-hook-form
const isFileUploadValid = (fileData, base64Data) => {
	const fileMimeType = getBase64MimeType(base64Data)
	if (fileData.size > MAX_UPLOAD_SIZE_IN_KB) {
		return false
	}
	if (!allowedMimeTypes.has(fileMimeType)) {
		return false
	}
	return true
}

const Upload = ({ control, setValue, errorText, uploadBtnText, attachmentText }) => {
	// TODO - combine display and base64 to one state with an object containing both arrays
	const [uploadedFilesDisplay, setUploadedFilesDisplay] = useState([])
	const [uploadedFilesBase64, setUploadedFilesBase64] = useState([])
	const [uploadErrorMessage, setUploadErrorMessage] = useState('')
	// in order to hide the default file upload button and text we use a ref to click the element even when it's hidden
	const inputFileRef = useRef(null)

	useEffect(() => {
		setValue('uploadFile', [])
	}, [])

	const onFileChange = async (event) => {
		const [fileData] = event.target.files
		const convertedFile = await convertToBase64(fileData)
		let currentFilesBase64 = [...uploadedFilesBase64]
		if (isFileUploadValid(fileData, convertedFile)) {
			setUploadedFilesDisplay((prevState) => [...prevState, fileData])

			// setting base64 files to variable to avoid setting an old value of the state to react-hook-form in setValue
			currentFilesBase64 = [...currentFilesBase64, convertedFile]
			setUploadedFilesBase64((prevState) => [...prevState, convertedFile])
			setValue('uploadFile', currentFilesBase64)
			setUploadErrorMessage('')
		} else {
			setUploadErrorMessage(
				// 'Please choose one of the following formats: jpg, jpeg, png, gif, mp4, mov, mp3, doc, docx, odt, pdf. Please attach maximum 5 files; Maximum size: 5 MB per file'
				errorText
			)
		}
	}

	// clicks the input element since it is hidden with css
	const onFileUpload = () => {
		inputFileRef.current.click()
	}

	const onFileDelete = (fileToDeleteIndex) => {
		const filteredBase64 = uploadedFilesBase64.filter((file) => file !== uploadedFilesBase64[fileToDeleteIndex])
		const filteredDisplay = uploadedFilesDisplay.filter((file) => file.name !== uploadedFilesDisplay[fileToDeleteIndex].name)
		setUploadedFilesDisplay(filteredDisplay)
		setUploadedFilesBase64(filteredBase64)
		setValue('uploadFile', filteredBase64)
	}

	return (
		<>
			{uploadErrorMessage && <StyledError>{uploadErrorMessage}</StyledError>}
			{uploadedFilesDisplay?.length < 5 && (
				<Controller
					name="uploadFile"
					defaultValue=""
					control={control}
					render={({ field, fieldState: { invalid, error } }) => (
						<StyledUploadContainer>
							<StyledUploadInput type="file" onChange={onFileChange} ref={inputFileRef} field={field} data-testid="file-upload-input" />
							<StyledUpload onClick={onFileUpload} data-testid="file-upload-button" role="button">
								<StyledText variant="BodyRegularHighlighted">{uploadBtnText}</StyledText>
							</StyledUpload>
						</StyledUploadContainer>
					)}
				/>
			)}
			{uploadedFilesDisplay && (
				<StyledList>
					{uploadedFilesDisplay.map((file, index) => (
						<StyledListItem key={`${file.name}-${index}`}>
							<StyledFileName component="p" variant="BodyRegular">
								{`${attachmentText}: `} {file.name}
							</StyledFileName>
							<StyledIconButton type="submit" onClick={() => onFileDelete(index)}>
								<ClearIcon />
							</StyledIconButton>
						</StyledListItem>
					))}
				</StyledList>
			)}
		</>
	)
}

export default Upload
